
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import Input from '../Input/index.vue'
import { dataSource_My } from '@xt/client/dataSource/my'

@Observer
@Component({
  components: {
    Input
  }
})
export default class WeChat extends Vue {
  specialty: string[] = []

  get specialtyOptions() {
    return dataSource_My.specialtyOptions
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  onSelect(s: { label: string; value: string }) {
    if (this.specialty.includes(s.value)) {
      this.specialty = this.specialty.filter(item => item !== s.value)
      return
    }

    this.specialty.push(s.value)
  }

  async onSubmit() {
    try {
      if (this.specialty.length === 0) {
        this.$msg('请选择至少一个特长')
        return
      }

      await this.UserStore.onUpdateUserInfo({
        id: this.UserStore.UserInfo.id,
        specialty: this.specialty.join('、')
      })

      this.$msg('保存成功', 'success')

      return true
    } catch (error) {}
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
